import { Component } from '@angular/core';
import { ApplicationType } from '../../../../shared/models/application-type';
import { LayoutService } from '../../../../shared/services/layout.service';
import { PortalStore } from '../../../services/portal.store';
import { PortalCommunicationService } from '../../../services/portal-communication.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

  //items!: MenuItem[];

  //@ViewChild('menubutton') menuButton!: ElementRef;

  //@ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  //@ViewChild('topbarmenu') menu!: ElementRef;

  constructor(
    private communication: PortalCommunicationService,
    public layoutService: LayoutService,
    public portalStore: PortalStore
  ) { }


  get isAuthenticated() {
    return this.portalStore.current.user;
  }

  get userEmail() {
    return this.portalStore.current.user?.username ?? '';
  }

  login() {
    this.communication.userLogin$.next(ApplicationType.Portal);
  }

  logout() {
    this.communication.userLogout$.next();
  }
}
